module.exports = __webpack_public_path__ + "images/emoji/hatched_chick.22beba08e9ab0fd2977a.png";